import { render, staticRenderFns } from "./GenreDetail.vue?vue&type=template&id=36c2307c"
import script from "./GenreDetail.vue?vue&type=script&lang=js"
export * from "./GenreDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports